export async function urlToBase64(url: string): Promise<string | null> {
  const data = await fetch(url);
  const blob = await data.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      if (typeof base64data === "string") {
        resolve(base64data);
      } else {
        resolve("");
      }
    };
    reader.onerror = reject;
  });
}
